import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "@/App.vue";
import router from "@/router";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/store/store";
import i18n from "@/plugins/i18n";
import permissions from "@/plugins/permission";
import VueCookies from "vue-cookies";
import "@/assets/global.css";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

Vue.use(VueCookies);
Vue.use(permissions);

// Registrace globálního filtrů
Vue.filter("joinWithSeparator", (strings, separator, empty = "") => {
  const result = strings.filter(str => str != null && str !== "").join(separator);

  if (result.length > 0)
    return result;
  else
    return empty;
});

export default new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),

  created() {
    // zruš scrollbary
    document.documentElement.style.overflow = "hidden";
  }
}).$mount("#app");
